// Copyright (c) 2016 Deere & Company

import SelectedDealers, {getDefaultState} from '../state/selected-dealers';
import actions from '../../actions-list';
import {updateList} from '../../../shared/services/list-selections';

const updateSelectAllDealers = (state, action) => {

    const toggleSelectedDealersState = state.length ? [] : action.dealers;

    return SelectedDealers.update(state, {
        $set: toggleSelectedDealersState
    });

};

const updateSelectedDealers = (state, action) =>
    SelectedDealers.update(state, {
        $set: updateList(
            action.dealer,
            action.isSelected,
            'account',
            state
        )
    });

const selectAllDealersOnLoad = (state, action) =>
    SelectedDealers.update(state, {
        $set: action.dealers
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_DUPLICATE_PIN_PLATE_CRITERIA]: selectAllDealersOnLoad,
        [actions.TOGGLE_ALL_DUPLICATE_PIN_PLATE_DEALERS]: updateSelectAllDealers,
        [actions.TOGGLE_ALL_DUPLICATE_PIN_PLATE_DEALERS_ON_LOAD]: selectAllDealersOnLoad,
        [actions.SELECT_DUPLICATE_PIN_PLATE_DEALER]: updateSelectedDealers
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/duplicate-pin-plate/reducers/selected-dealers.js